var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,{tag:"div",staticClass:"ShadowBevel",style:(_vm.computedStyles)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }